/* v2.js - behaviour for the v2 (cadence) design on pages outside the homepage. LIVE 29/09/2026.
   Loaded by layout/theme.liquid on body.v2 pages.
   - [data-v2-faq]: an FAQ section of <details> becomes the homepage's conversation: one exchange on screen
     at a time, the first question answered on arrival, a tapped question replacing it. The original list
     stays in the page (hidden once the chat is built), so the content, its links and the FAQPage schema
     are unchanged, and without JavaScript the accordions still work.
   - [data-v2-arrows]: rail buttons that scroll most of a screen and wrap at either end.
   - video[data-v2-clip]: plays only while on screen. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- older pages: find their FAQ sections so they become the chat too (30/09/2026). A section counts
     when its heading reads as a FAQ and it holds three or more drop-downs. ---------- */
  $$('section h2, section h3').forEach(function (h) {
    if (!/question|answer|faq|good to know|need to know/i.test(h.textContent)) { return; }
    var sec = h.closest('section'); if (!sec || sec.hasAttribute('data-v2-faq') || sec.closest('.h26-buy, #b250-buy')) { return; }
    if ($$('details', sec).length >= 3) { sec.setAttribute('data-v2-faq', ''); }
  });

  /* ---------- headlines: a light line with the key words in weight, as on the homepage (30/09/2026). Only
     headings that are plain text (and line breaks) are touched: after the last sentence break, else after the
     last comma, else the last word (two when the last is short). Screen readers read the same words. ---------- */
  $$('main h1, main h2').forEach(function (h) {
    if (h.closest('.rda-ftr, .v2-dose, .v2-flav, .v2-cmp, [data-v2-keep]') || h.querySelector('b, strong, em, span, a, img, svg, sup, sub')) { return; }
    var html = h.innerHTML.trim(); if (!html || /<(?!br\s*\/?>)/i.test(html)) { return; }
    var cut = -1, m;
    var re = /[.?!](\s|<br\s*\/?>)+(?=\S)/gi; while ((m = re.exec(html))) { cut = m.index + m[0].length; }
    if (cut < 0) { var c = html.lastIndexOf(', '); if (c > 0) { cut = c + 2; } }
    if (cut < 0) {
      var words = html.split(/(\s+|<br\s*\/?>)/i).filter(function (x) { return x !== undefined; });
      var idx = []; words.forEach(function (w, i) { if (w.trim() && !/^<br/i.test(w)) { idx.push(i); } });
      if (idx.length < 2) { return; }
      var take = words[idx[idx.length - 1]].replace(/[^A-Za-z]/g, '').length <= 3 && idx.length > 2 ? 2 : 1;
      var from = idx[idx.length - take]; cut = words.slice(0, from).join('').length;
    }
    if (cut <= 0 || cut >= html.length) { return; }
    h.innerHTML = html.slice(0, cut) + '<b>' + html.slice(cut) + '</b>';
  });

  /* ---------- FAQ as a conversation ---------- */
  $$('[data-v2-faq]').forEach(function (sec) {
    var items = $$('details', sec).map(function (d) {
      var sum = $('summary', d);
      var q = sum ? sum.textContent.replace(/\s+/g, ' ').trim() : '';
      var body = d.cloneNode(true); var s2 = $('summary', body); if (s2) { s2.remove(); }
      return { q: q, a: body.innerHTML.trim() };
    }).filter(function (x) { return x.q && x.a; });
    if (!items.length) { return; }
    var list = $$('details', sec)[0].parentNode;
    var chat = document.createElement('div');
    chat.className = 'v2-chat';
    chat.innerHTML = '<div class="v2-chat-thread" aria-live="polite"></div><div class="v2-chat-chips"><p class="v2-chat-hint">Tap a question to see the answer.</p></div>';
    var thread = $('.v2-chat-thread', chat), chips = $('.v2-chat-chips', chat), timer = null;
    /* data-v2-faq-more="6" (03/10/2026, the Base 250 page): only the first six questions show as chips, the rest
       behind a "More questions" chip. Every question stays in the page and the schema. */
    var more = +sec.getAttribute('data-v2-faq-more') || 0;
    items.forEach(function (it, i) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = it.q; b.setAttribute('data-i', i);
      if (more && i >= more) { b.hidden = true; }
      chips.appendChild(b);
    });
    if (more && items.length > more) {
      var mb = document.createElement('button'); mb.type = 'button'; mb.className = 'v2-chat-more'; mb.textContent = 'More questions';
      mb.addEventListener('click', function (e) { e.stopPropagation(); $$('button[hidden]', chips).forEach(function (x) { x.hidden = false; }); mb.remove(); });
      chips.appendChild(mb);
    }
    function bubble(html, who) { var m = document.createElement('div'); m.className = 'v2-msg v2-msg--' + who; if (who === 'you') { m.textContent = html; } else { m.innerHTML = html; } thread.appendChild(m); return m; }
    function show(i, instant) {
      clearTimeout(timer);
      $$('button', chips).forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-i') === i ? 'true' : 'false'); });
      thread.innerHTML = '';
      bubble(items[i].q, 'you');
      if (instant || reduce) { bubble(items[i].a, 'us'); return; }
      var t = bubble('', 'us'); t.classList.add('is-typing'); t.innerHTML = '<i></i><i></i><i></i>';
      timer = setTimeout(function () { t.classList.remove('is-typing'); t.innerHTML = items[i].a; }, 600);
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !b.hasAttribute('data-i')) { return; }
      show(+b.getAttribute('data-i'));
      if (thread.getBoundingClientRect().top < 80) { thread.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
    });
    list.parentNode.insertBefore(chat, list);
    list.hidden = true;
    sec.classList.add('is-chat');
    show(0, true);
  });

  /* ---------- rail arrows, wrapping ---------- */
  $$('[data-v2-arrows]').forEach(function (nav) {
    var rail = $(nav.getAttribute('data-v2-arrows')); if (!rail) { return; }
    var go = reduce ? 'auto' : 'smooth';
    function max() { return rail.scrollWidth - rail.clientWidth; }
    $$('button', nav).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = +b.getAttribute('data-dir'), m = max();
        if (d > 0 && rail.scrollLeft >= m - 4) { rail.scrollTo({ left: 0, behavior: go }); }
        else if (d < 0 && rail.scrollLeft <= 4) { rail.scrollTo({ left: m, behavior: go }); }
        else { rail.scrollBy({ left: d * rail.clientWidth * 0.8, behavior: go }); }
      });
    });
    function fit() { nav.hidden = max() <= 0; }
    window.addEventListener('resize', fit); fit();
  });

  /* ---------- Why the dose: the picture and its tag follow the open item ---------- */
  $$('[data-v2-dose]').forEach(function (root) {
    var imgs = $$('.v2-dose-fig img', root), tag = $('[data-v2-dose-tag]', root);
    $$('details', root).forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) { return; }
        imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-i') === d.getAttribute('data-i')); });
        if (tag) { tag.textContent = ($('.v2-dose-name', d) || {}).textContent || ''; }
      });
    });
  });

  /* ---------- rise-in sections (the comparison's Base 250 column and its sachets) ---------- */
  var rise = $$('[data-v2-rise]');
  if (rise.length) {
    if (!('IntersectionObserver' in window) || reduce) { rise.forEach(function (el) { el.classList.add('is-in'); }); }
    else {
      var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } }); }, { threshold: 0.3 });
      rise.forEach(function (el) { rio.observe(el); });
    }
  }

  /* ---------- clip covers load when the rail nears the screen (03/10/2026, Research 43: seven covers loaded with
     the page, well below the fold). v2-clips prints them as data-poster at 600px. ---------- */
  var covers = $$('video[data-poster]');
  if (covers.length) {
    var setCover = function (v) { if (v.getAttribute('data-poster')) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); } };
    if (!('IntersectionObserver' in window)) { covers.forEach(setCover); }
    else {
      var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { setCover(e.target); cio.unobserve(e.target); } }); }, { rootMargin: '600px 600px' });
      covers.forEach(function (v) { cio.observe(v); });
    }
  }

  /* ---------- clips play only while on screen ---------- */
  var clips = $$('video[data-v2-clip]');
  if (clips.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.5 });
    clips.forEach(function (v) { io.observe(v); });
  }
})();
